
import _ from 'lodash';
import ProductUtil from '@/utils/product-util';

const isNegative = (state)=>(nbDays, quantity)=>{
  if(state.inventory!=null && state.inventory.delay_management && quantity>0){
    return nbDays>=state.inventory.product_delay;
  }
  return false;
}
const canReserveSelectedProduct = (state)=>{
  if(state.selectedProduct != null && _.get(state, 'inventory.ind_reservation') === true){
    return ( state.selectedProduct.quantity.inStock > 0 ||
             (state.selectedProduct.quantity.pending - state.selectedProduct.quantity.reservedNewShipment ) > 0
           );
  }
  return false;
}

const isIntermediary = (state)=>(nbDays, quantity)=>{
  if(state.inventory!=null && state.inventory.delay_management && quantity>0){
    return nbDays<state.inventory.product_delay && nbDays > (state.inventory.product_delay/2);
  }
  return false;
}

const isPositive = (state)=>(nbDays, quantity)=>{
  if(state.inventory!=null && state.inventory.delay_management && quantity>0){
    return nbDays<=(state.inventory.product_delay/2)
  }
  return false;
}

const getSelectedProductId = (state) =>{
  if(state.selectedProduct!=null){
    return state.selectedProduct.id;
  }else{
    return null;
  }
}

const showProductColumn = (state) => {
  return _.find(state.columns, c => c.code === 'product') != null;
}

const showProviderColumn = (state) => {
  return _.find(state.columns, c => c.code === 'provider') != null;
}

const showTypeColumn = (state) => {
  return _.find(state.columns, c => c.code === 'type') != null;
}

const showTagsColumn = (state) => {
  return _.find(state.columns, c => c.code === 'tags') != null;
}

const showFormatColumn = (state) => {
  return _.find(state.columns, c => c.code === 'format') != null;
}

const showUVCColumn = (state) => {
  return _.find(state.columns, c => c.code === 'uvc') != null;
}

const showPriceColumn = (state) => {
  return _.find(state.columns, c => c.code === 'price') != null;
}

const showPriceDetailColumn = (state) => {
  return _.find(state.columns, c => c.code === 'priceDetail') != null;
}

const showDelayColumn = (state) => {
  return _.find(state.columns, c => c.code === 'delay') != null;
}

const showQtyColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qty') != null;
}

const showQtyReservedColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtyReserved') != null;
}

const showQtyReservedNextBatchColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtyReservedNextBatch') != null;
}

const showQtyInCommandColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtyInCommand') != null;
}

const showQtySoldColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtySold') != null;
}

const showQtyInventoryColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtyInventory') != null;
}

const showQtyToReceiveColumn = (state) => {
  return _.find(state.columns, c => c.code === 'qtyToReceive') != null;
}

const showAgencyFeeColumn = (state) => {
  return _.find(state.columns, c => c.code === 'agencyFee') != null;
}


const waitingPurchaseOrders = (state)=>{
  let waitingPurchaseOrdersInfo = [];
  _.forEach(state.selecteProductPurchaseOrders, po=>{
    if(po.status.code != "RECEIVED" && po.status.code !="CANCELLED" && po.status.code !="DRAFT" && po.status.code !="IMPORTED"){
      _.forEach(po.lines, line=>{
        if(line.puid == state.selectedProduct.puid){
          let purchaseAndItemsInfo = {};
          purchaseAndItemsInfo.reception_planning_date = po.reception_planning_date;
          purchaseAndItemsInfo.reference = line.reference;
          purchaseAndItemsInfo.qty_ordered = line.qty_ordered;
          const extraInfo = ProductUtil.convertPurchaseOrderExtraInfoToProductExtraInfo(line.extraInfo);
          purchaseAndItemsInfo.extraInfo = extraInfo;
          purchaseAndItemsInfo.id = po.id;
          purchaseAndItemsInfo.po_number = po.po_number;
          purchaseAndItemsInfo.description = line.description;
          purchaseAndItemsInfo.status = po.status;
          purchaseAndItemsInfo.productItem = line.productItem;
          purchaseAndItemsInfo.qty_to_receive = line.purchase_status.qty_ordered-line.purchase_status.qty_received;
          if(purchaseAndItemsInfo.qty_to_receive>0){
            waitingPurchaseOrdersInfo.push(purchaseAndItemsInfo);
          }
        }
      })


    }
  })
  return waitingPurchaseOrdersInfo;
}

const providerName = (state) => (provider) =>{
  return provider.usualName!=null?provider.usualName:provider.name;
}

//DEPRECATED use getSelectedProductAvailableBatch instead
const getselectedProductItemsLeft = (state) => {
  let items = [];
  _.forEach(state.selectedProductItems, i=>{
    items.push(i);

  })
  return items;
}

const getSelectedProductAvailableBatch = (state) => {
  return _.get(state.selectedProduct, 'items');
}




const getSelectedProductItemsOnHandQuantity = (state) =>{
  let on_hand = 0;
  let items = [];
  _.forEach(state.selectedProductItems, i=>{
    on_hand+=i.quantity.on_hand;

  })
  return on_hand;
}

const topVintage = (state, getters) => {
  if (_.get(state.selectedProduct, 'item.extraInfo.vintage') != null) {
    return _.get(state.selectedProduct, 'item.extraInfo.vintage');
  }
  return getters.waitingTopVintage;
}
const waitingTopVintage = (state, getters) => {
  return _.get(_.head(getters.waitingPurchaseOrders), 'extraInfo.vintage');
}

const getNbFiltersCriteria = (state) => {
  let nb = 0;
  if(state.filters.productWithQuantity === true)nb++;
  if(state.filters.productInSupply === true)nb++;
  if(state.filters.providerId === true)nb++;
  if(state.filters.checkedTags.length>0)nb += state.filters.checkedTags.length;
  if(state.filters.productPublishedInd != null) nb++;
  if((state.filters.cmsProductTypes || []).length > 0) nb++;
  if((state.filters.cmsSpecificProductTypes || []).length > 0) nb++;
  return nb;
}

const getFilterPublishedInd = (state) => {
  if (state.filters.productPublishedInd === true) {
    return 1;
  } else if (state.filters.productPublishedInd === false) {
      return 0;
  }
  return 2;
}



const getFilterProductAvailabilityInd = (state) => {
  if (state.filters.productWithQuantity === true && state.filters.productInSupply === true) {
    return ['1','0'];
  } else if (state.filters.productWithQuantity === true) {
      return ['1'];
  } else if (state.filters.productInSupply === true) {
      return ['0'];
  }
  return ['2'];
}

const nbProductsFound = (state) => {
  return _.get(state, 'count');
}

const getCurrentInventoryName = (state) => {
  return _.get(state, 'inventory.name');
}

export default {
  nbProductsFound,
  showTypeColumn,
  showProductColumn,
  showProviderColumn,
  showTagsColumn,
  showFormatColumn,
  showUVCColumn,
  showPriceColumn,
  showPriceDetailColumn,
  showDelayColumn,
  showQtyToReceiveColumn,
  showAgencyFeeColumn,
  showQtyColumn,
  showQtyToReceiveColumn,
  waitingPurchaseOrders,
  isNegative,
  isIntermediary,
  isPositive,
  getSelectedProductId,
  canReserveSelectedProduct,
  providerName,
  getselectedProductItemsLeft,
  getSelectedProductItemsOnHandQuantity,
  showQtyReservedColumn,
  showQtyReservedNextBatchColumn,
  showQtyInventoryColumn,
  showQtyInCommandColumn,
  showQtySoldColumn,
  getSelectedProductAvailableBatch,
  topVintage,
  waitingTopVintage,
  getNbFiltersCriteria,
  getFilterPublishedInd,
  getFilterProductAvailabilityInd,
  getCurrentInventoryName,
};
